import { createAction } from 'redux-actions'
import { RootState } from '../reducers'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { url, post } from '../../assets/javascripts/http'
import { message, Modal } from 'antd'
import { OrganizationService, PostureService, MobileAccountService, MobileCaptchaService } from "../adapters"
import { isHasBasicInfo } from '../../assets/javascripts/generic'
import { actionGetInstitution } from './institution'

let organizationService = new OrganizationService(url, post);
let postureService = new PostureService(url, post);
let mobileAccountService = new MobileAccountService(url, post);
let mobileCaptchaService = new MobileCaptchaService(url, post);

export async function getPostureData(): Promise<any> {
    let postureData: any = Object.assign({});
    try {
        postureData = await postureService.getPostureReport({
            uuid: "c9df70e2-4d05-409c-9822-7c11a1dd2736",
            language: "zh",
        })

    } catch (error: any) {

    }
    return postureData
}
message.config({
    duration: 0,
    maxCount: 3,
});

export function actionLogin(data) {
    return async (dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        try {
            message.loading('正在登陆...');
            let res = await mobileAccountService.loginByPassword({
                countryCode: '86',
                mobileNumber: data.username,
                password: data.password,
                client: "posture_detection_app"
            });
            
            if (!res.accessToken) {
                message.destroy();
                message.error('登录失败!', 0)
                return;
            }

            //获取账号组织Id
            localStorage.setItem('accessToken', res.accessToken);
            let organizationId, name;
            try {
                let res_org = await organizationService.getAccountGroupContext({});
                let data_o = {
                    type: 'posture.expert.platform'
                }
                let res_o = await organizationService.getOrganizationsByType(data_o)

                res_org.accountGroups.map((item) => {
                    let org = res_o.organizations.filter((o) => {
                        return o.id === item.organizationId
                    })[0] || {};
                    if (org.id) {
                        organizationId = item.organizationId;
                        name = item.name;
                    }
                })
                let data_type = {
                    type: 'posture.expert'
                }
                let res_type = await organizationService.getOrganizationsByType(data_type)
                let organizationId_expert = res_type.organizations[0].id || -1;

                localStorage.setItem('organizationId_expert', organizationId_expert + '')
                localStorage.setItem('organizationId', organizationId);
                localStorage.setItem('name', name)

            } catch (error: any) {

            }

            //判断是否有权限
            await dispatch(actionGetInstitution())
            let institution = getState().institution.institution || {};
            if(institution.status === '待激活') {
                message.destroy();
                Modal.error({
                    className: 'modal_access',
                    title: '该账号试用已结束',
                    content: '请联系创感科技工作人员激活账号'
                })
                return ;
            }
            if(institution.status !== '试用' && institution.accessAuthorized !== 'ALL') {
                message.destroy();
                Modal.error({
                    className: 'modal_access',
                    title: '该账号没有登录后台权限',
                    content: '请联系创感科技工作人员开启权限'
                })
                return ;
            }
           
            localStorage.setItem('status', 'true');
            dispatch(actionLoginSuccess({
                accessToken: res.accessToken,
                organizationId: organizationId,
                name: name
            }))
            
            message.destroy();
        } catch (error: any) {
            message.destroy();
            message.error('登陆失败', 0);
            dispatch(actionLoginFail({
                data: '抱歉，服务器出错了',
                status: true
            }))
            console.log(error);
        }
    }
}

export const ACTION_LOGIN_SUCCESS = 'USER.ACTION_LOGIN_SUCCESS';

export interface ActionLoginSuccessPayload {
    accessToken: string,
    organizationId: any,
    name: string
}
export const actionLoginSuccess = createAction(
    ACTION_LOGIN_SUCCESS,
    (payload: ActionLoginSuccessPayload) => {
        return payload
    }
);

export const ACTION_LOGIN_FAILL = 'USER.ACTION_LOGIN_FAILL';

export interface ActionLoginFailPayload {
    data: any,
    status: boolean
}
export const actionLoginFail = createAction(
    ACTION_LOGIN_FAILL,
    (payload: ActionLoginFailPayload) => {
        return payload
    }
);


export const ACTION_LOGOUT_SUCCESS = 'USER.ACTION_LOGOUT_SUCCESS';

export interface ActionLogoutSuccessPayload {
    loginStatus: boolean
    invaildLogin?: boolean
}
export const actionLogoutSuccess = createAction(
    ACTION_LOGOUT_SUCCESS,
    (payload: ActionLogoutSuccessPayload) => {
        return payload
    }
);

export function actionChangePassword(data) {
    return async (dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if (!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({
                loginStatus: false
            }))
            return;
        }
        try {
            
            let dataArg = {
                countryCode: '86',
                mobileNumber: data.phone,
                captcha: data.captcha,
                password: data.newPassword
            }
            await mobileAccountService.setPasswordForMobile(dataArg)
           
            dispatch(actionChangePasswordSuccess({
                menuData: {}
            }))
            message.success('修改成功', 3)

        } catch (error: any) {
            console.log(error);
        }
    }
}

export const ACTION_CHANGEPASSWORD_SUCCESS = 'USER.ACTION_CHANGEPASSWORD_SUCCESS';

export interface ActionChangePasswordSuccessPayload {
    menuData: any
}
const actionChangePasswordSuccess = createAction(
    ACTION_CHANGEPASSWORD_SUCCESS,
    (payload: ActionChangePasswordSuccessPayload) => {
        return payload
    }
);


export function actionSendCaptcha(data) {
    return async (dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if (!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({
                loginStatus: false
            }))
            return;
        }
        try {
            data.countryCode = '86';
            await mobileCaptchaService.generate(data)
            dispatch(actionSendCaptchaSuccess({
                menuData: {}
            }))
            message.success('发送成功', 3)

        } catch (error: any) {
            console.log(error);
        }
    }
}

export const ACTION_SENDCAPTCHA_SUCCESS = 'USER.ACTION_SENDCAPTCHA_SUCCESS';

export interface ActionSendCaptchaSuccessPayload {
    menuData: any
}
const actionSendCaptchaSuccess = createAction(
    ACTION_SENDCAPTCHA_SUCCESS,
    (payload: ActionSendCaptchaSuccessPayload) => {
        return payload
    }
);